import _ from "lodash";
import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";
import { utilService } from "../../../services/utilService";
import {
  addScheduleListReq,
  addScheduleListRes,
} from "./Models/AddScheduleList.model";
import {
  selectScheduleListReq,
  selectScheduleListRes,
} from "./Models/SelectScheduleList.model";
import {
  submitScheduleListReq,
  submitScheduleListRes,
} from "./Models/SubmitScheduleList.model";

const selectedScheduleData: any = [];

const getRequestCoverageSubmitScheduleList = async (
  params: submitScheduleListReq
): Promise<submitScheduleListRes> => {
  const respApiResult = await apiService
    .apiCall(
      `user/multi-schedulenames-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as submitScheduleListRes;
      const submitScheduleListResponse = setSubmitScheduleListModel(
        submitScheduleListResp
      );
      const result: submitScheduleListRes = {
        isSuccess: true,
        result: submitScheduleListResponse,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: submitScheduleListRes = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getRequestCoverageAddScheduleList = async (
  params: addScheduleListReq
): Promise<addScheduleListRes> => {
  const respApiResult = await apiService
    .apiCall(
      `user/schedulenames/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const addScheduleListResp = res as addScheduleListRes;
      var resultData: any;
      if (addScheduleListResp.result) {
        resultData = mapAddScheduleListResult(addScheduleListResp.result);
      }
      const result: addScheduleListRes = {
        isSuccess: true,
        result: resultData,
        status: addScheduleListResp.status,
        message: addScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: addScheduleListRes = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        result: [],
      };
      return result;
    });

  return respApiResult;
};

const mapAddScheduleListResult = (payload: Array<any>) => {
  let resultListArray = payload.map((object: any) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: object.data,
    };
  });
  return resultListArray;
};

const getRequestCoverageSelectScheduleList = async (
  params: selectScheduleListReq
): Promise<selectScheduleListRes> => {
  const respApiResult = await apiService
    .apiCall(
      `user/multi-schedulenames-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const selectScheduleListResp = res as selectScheduleListRes;
      const selectScheduleListResponse = mapSelectScheduleResponse(
        selectScheduleListResp.result
      );
      const result: selectScheduleListRes = {
        isSuccess: true,
        result: selectScheduleListResponse,
        status: selectScheduleListResp.status,
        message: selectScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: selectScheduleListRes = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        result: [],
      };
      return result;
    });

  return respApiResult;
};

const mapSelectScheduleResponse = (data: any) => {
  var mappedData: any = [];
  if (!_.isEmpty(data)) {
    mappedData = data.map((dataItem: any) => {
      return {
        added_groups: mapOwnAndAddedGroups(dataItem.added_groups),
        own_groups: mapOwnAndAddedGroups(dataItem.own_groups),
      };
    });
  }
  return mappedData;
};

const mapOwnAndAddedGroups = (data: any) => {
  var mappedGroupDetails: any = [];
  if (!_.isEmpty(data)) {
    mappedGroupDetails = data.map((dataItem: any) => {
      return {
        id: dataItem.id,
        isSelected: dataItem.is_selected,
        name: dataItem.name,
        scheduleName: dataItem.schedule_name,
      };
    });
  }
  return mappedGroupDetails;
};

const getScheduleItem = (data: any, key: string) => {
  const selectedScheduleData = data;
  const scheduleList: any = [];
  selectedScheduleData.forEach((element: any) => {
    if (element.isSelected || element.name === "ALL") {
      scheduleList.push(element[key]);
    }
  });
  return scheduleList;
};

//submit schedule
const setSubmitScheduleListModel = (payload: submitScheduleListRes): any => {
  let SubmitScheduleListArray = payload.result?.map((object: any) => {
    return {
      ownGroups: object.own_groups,
      addedGroups: object.added_groups,
      regCode: object.reg_code,
    };
  });
  return SubmitScheduleListArray;
};

const getSelectedScheduleId = (schedules: any) => {
  var selectedScheduleId: any;
  schedules &&
    schedules.forEach((element: any) => {
      if (element.isSelected) {
        selectedScheduleId = element["id"];
      }
    });
  return selectedScheduleId;
};

const getSelectedScheduleIdList = (schedules: any) => {
  const selectedScheduleIds: any = [];
  schedules &&
    schedules.forEach((element: any) => {
      if (element.isSelected) {
        selectedScheduleIds.push(element["id"]);
      }
    });
  return selectedScheduleIds;
};

const handleErrorResponse = () => {};

export const scheduleListService = {
  getRequestCoverageSelectScheduleList,
  getRequestCoverageAddScheduleList,
  getRequestCoverageSubmitScheduleList,
  getSelectedScheduleId,
  getSelectedScheduleIdList,
  getScheduleItem,
  selectedScheduleData,
  handleErrorResponse,
};
